<template>
  <div>
    <a-modal modal-id="add-account">
      <div slot="title">Add Account</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <label for="">Code</label>
            <input type="text" name="" id="" class="form-control" placeholder="Code" v-model="addAccount.Code">
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Name</label>
            <input type="text" name="" id="" class="form-control" placeholder="Name" v-model="addAccount.Name">
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Description</label>
            <textarea class="form-control" placeholder="Description" v-model="addAccount.Description" rows="5"></textarea>
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Type</label>
            <v-select placeholder="Type" v-model="addAccount.Type" :options="types" index="index"></v-select>
          </div>
          <div class="col-lg-12 m-b-sm">
            <button class="btn btn-primary btn-sm pull-right" @click="saveAccount"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </div>
    </a-modal>
    <in-wrapper>
      <in-ibox>
        <div slot="title">
          Accounts
          <a class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-account"><i
            class="fa fa-plus" @click="addAccount = {}"></i> New Account</a>
        </div>
        <div slot="content" class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-2">
                <label for="">Status</label>
              </div>
            </div>
            <table class="table table-striped table-hover m-t-sm">
              <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Type</th>
                <th>Status</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="account in accounts" :key="account.AccountID" v-if="accounts">
                <td>{{ account.Code }}</td>
                <td>{{ account.Name }}</td>
                <td>{{ account.Type }}</td>
                <td>{{ account.Status }}</td>
                <td><button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-account" @click="setAccount(account)"><i class="fa fa-edit"></i> Edit</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      filters: {},
      addAccount: {},
      types: []
    }
  },
  computed: {
    ...mapGetters({
      accounts: 'getXeroAccounts'
    })
  },
  mounted () {
    if (!this.accounts.length) {
      this.$store.dispatch('fetchXeroAccounts')
      console.log(this.accounts)
    }
    this.$store.dispatch('fetchData', 'xero-account-types').then(r => {
      this.types = r.data.values
    })
  },
  methods: {
    async loadAccounts () {
      try {
        this.accounts = (await axios.get(`/integrations/xero/accounts`)).data
      } catch (e) {
      }
    },
    async saveAccount () {
      try {
        axios.post(`/integrations/xero/accounts`, this.addAccount)
        this.addAccount = {}
        $('#add-account').modal('hide')
      } catch (e) {
        console.log(e)
      }
    },
    setAccount (account) {
      this.addAccount = {
        Code: account.Code,
        Name: account.Name,
        Type: account.Type
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Accounts.vue